module.exports = __webpack_public_path__ + "static/media/p13_img1.144d4337.png";